// 🔥 Firebase Core (compat + modular mixed setup)
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';

import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

import { getFirebaseToken } from '../redux/slices/user/userDetails';

//
// 🔥 Firebase App Init
//


const app =
  firebase.apps.length === 0
    ? firebase.initializeApp({
        apiKey: 'AIzaSyAUM6p8FYYP1QCpc4BUmxa5mihUho1_5yA',
        authDomain: 'lomavis-prod-eu.firebaseapp.com',
        databaseURL:
          'https://lomavis-prod-eu-default-rtdb.europe-west1.firebasedatabase.app',
        projectId: 'lomavis-prod-eu',
        storageBucket: 'lomavis-prod-eu.appspot.com',
        messagingSenderId: '783431336947',
        appId: '1:783431336947:web:f87fd1a25204bc8cffc886'
      }
      // { // apiKey: 'AIzaSyA9x47AgH9FViXt5ZSAOpo6D5majH3lRiQ', // authDomain: 'lomavis-development.firebaseapp.com', // databaseURL: // 'https://lomavis-development-default-rtdb.europe-west1.firebasedatabase.app', // projectId: 'lomavis-development', // storageBucket: 'lomavis-development.appspot.com', // messagingSenderId: '951363988806', // appId: '1:951363988806:web:91a98779c451b8b5d18947' // }
      )
    : firebase.app();

//
// 🔥 App Check
//
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LfV38IgAAAAAOdesgwnW7iA5EEzU3Vd3coVtH2f'),
  isTokenAutoRefreshEnabled: true
});
// '6LeAhKQgAAAAAAfJ9VZzBq0FJwewfDdY4kmoijRI'

//
// 🚨🔥 FIRESTORE CORPORATE FIREWALL + LOCAL CACHE 🔥🚨
//
// ✔ funktioniert in Firmen-Netzwerken
// ✔ lädt Daten beim zweiten Besuch sofort aus IndexedDB
// ✔ reduziert Firestore Reads → spart Kosten
//

export const firestore = initializeFirestore(app, {
  // Corporate firewall safe
  experimentalForceLongPolling: true,

  // ⭐⭐ LOCAL PERSISTENT CACHE ⭐⭐
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
} as any);

//
// 🔥 Realtime DB (kein Fix nötig)
//
export const database = firebase.database();

//
// 🔥 Storage
//
export const storage = getStorage(app);

//
// 🔥 Auth
//
const auth = getAuth();

getFirebaseToken()
  .then((token) => signInWithCustomToken(auth, token))
  .then((userCredential) => {
    console.log('Firebase login successful', userCredential.user?.uid);
  })
  .catch((error) => {
    console.error('Firebase auth error:', error);
  });
